import { UPLOAD_FILE_TIMEOUT_MS } from '@repo/contracts';
import { uploadAxiosConfig } from '../utils/upload-axios-config.js';
import { BaseApi } from './base.api.js';

export class OperationalRunApi extends BaseApi {
    constructor(client) {
        super(client, '/operational-runs');
    }

    async startFromCrisis(sourceId, data = {}) {
        return (await this.client.post(`${this.basePath}/start/crisis-event/${sourceId}`, data)).data;
    }

    async startFromExercise(sourceId, data = {}) {
        return (await this.client.post(`${this.basePath}/start/exercise/${sourceId}`, data)).data;
    }

    async getBoard(id) {
        return (await this.client.get(`${this.basePath}/${id}/board`)).data;
    }

    async getHistory(id, params = {}) {
        return (await this.client.get(`${this.basePath}/${id}/history`, { params })).data;
    }

    async getUpdates(id, params = {}) {
        return (await this.client.get(`${this.basePath}/${id}/updates`, { params })).data;
    }

    async appendUpdate(id, data) {
        return (await this.client.post(`${this.basePath}/${id}/updates`, data)).data;
    }

    async startTask(id, taskId) {
        return (await this.client.post(`${this.basePath}/${id}/tasks/${taskId}/start`)).data;
    }

    async completeTask(id, taskId, data = {}) {
        return (await this.client.post(`${this.basePath}/${id}/tasks/${taskId}/complete`, data)).data;
    }

    async listTaskEvidence(id, taskId) {
        return (await this.client.get(`${this.basePath}/${id}/tasks/${taskId}/evidence`)).data;
    }

    async uploadTaskEvidence(id, taskId, file) {
        const form = new FormData();
        form.append('file', file, file?.name || 'evidence');
        return (await this.client.post(
            `${this.basePath}/${id}/tasks/${taskId}/evidence`,
            form,
            uploadAxiosConfig({
                timeout: UPLOAD_FILE_TIMEOUT_MS,
                headers: { 'Content-Type': 'multipart/form-data' },
            }),
        )).data;
    }

    async downloadTaskEvidence(id, taskId, evidenceId) {
        return (await this.client.get(
            `${this.basePath}/${id}/tasks/${taskId}/evidence/${evidenceId}/download`,
            { responseType: 'blob' },
        )).data;
    }

    async overrideDependencies(id, taskId, data) {
        return (await this.client.post(`${this.basePath}/${id}/tasks/${taskId}/override-dependencies`, data)).data;
    }

    async reassignTask(id, taskId, data) {
        return (await this.client.post(`${this.basePath}/${id}/tasks/${taskId}/reassign`, data)).data;
    }

    async pause(id, data) {
        return (await this.client.post(`${this.basePath}/${id}/pause`, data)).data;
    }

    async resume(id, data = {}) {
        return (await this.client.post(`${this.basePath}/${id}/resume`, data)).data;
    }

    async complete(id, data = {}) {
        return (await this.client.post(`${this.basePath}/${id}/complete`, data)).data;
    }

    async cancel(id, data) {
        return (await this.client.post(`${this.basePath}/${id}/cancel`, data)).data;
    }
}
